import { Badge, Box, Button, Card, CardContent, Chip, DialogTitle, Grid, LinearProgress, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Api from '../../Api';
import { IMaterial, IMaterialAuditDetail } from '../../interfaces';
import './index.scss';
import { NoDetailNotice } from './NoDetailNotice';

export const Audits: React.SFC<{ material: IMaterial, load: boolean }> = ({
    load,
    material
}) => {

    useEffect(() => {
        if (material.materialId && load === true)
            Api.Materials.Audits.get(material.materialId).then((response: any) => {
                setAudits(response as IMaterialAuditDetail[]);
                setLoading(false);
            });
    }, [material.materialId, load])

    const navigate = useNavigate();
    const [audits, setAudits] = useState<IMaterialAuditDetail[]>([]);
    const [loading, setLoading] = useState(true);

    const formatDate = (dateString: string | null | undefined): string | null => {
        if (!dateString) return null;

        const date = new Date(dateString);
        if (isNaN(date.getTime())) return null;

        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();

        return `${day}/${month}/${year}`;
    };

    const isOverdue = (dateString: string | null | undefined): boolean => {
        if (!dateString) return false;

        const date = new Date(dateString);
        const today = new Date();

        return (date < today);
    };

    const lastAuditDate = formatDate(material.lastAuditDate);
    const nextAuditDate = formatDate(material.nextAuditDate);
    const nextAuditOverdue = isOverdue(material.nextAuditDate);

    return (
        (load === false || loading) ? <LinearProgress /> :
            <Grid container xs={12} gap={2}>
                <Grid item xs={6}>
                    <Typography className="material-property-text">
                        <strong>Audit History</strong>
                    </Typography>
                    <ul className="material-audit-list">
                        {audits.length === 0 && <NoDetailNotice label="audit history" />}
                        {audits.map((a, i) => (
                            <li key={i}>
                                <Button variant="text" onClick={() => {
                                    navigate('/audit/update/' + a.materialAuditId);
                                }} >
                                    <Grid container >
                                        <Grid xs={"auto"} display="flex" alignItems="center">
                                            <Typography sx={{ mr: 4 }}>{a.materialAuditReference}</Typography>
                                        </Grid>
                                        <Grid xs={"auto"} display="flex" alignItems="center">
                                            <Typography sx={{ mr: 4 }} fontSize="small">{a.dateCreated ? new Date(a.dateCreated).toLocaleDateString("en-GB") : ""}</Typography>
                                        </Grid>
                                        <Grid display="flex" alignItems="center">
                                            {(a.passed === false && a.failed === false) && <Chip label="Pending" color="info" variant="outlined" />}
                                            {(a.passed === true && a.failed === false) && <Chip label="Passed" color="success" />}
                                            {(a.passed === false && a.failed === true) && <Chip label="Failed" color="error" />}
                                        </Grid>
                                        <Grid display="flex" alignItems="center">
                                            {a.dateClosed === null &&
                                                <Typography
                                                    marginLeft={2}
                                                    fontSize="small"
                                                    textTransform="none" >this audit not complete</Typography>}
                                            {a.failed === true &&
                                                <Typography
                                                    marginLeft={2}
                                                    fontSize="small"
                                                    textTransform="none" >{a.discrepancy}</Typography>
                                            }
                                        </Grid>
                                    </Grid>
                                </Button>
                            </li>
                        ))}
                    </ul>
                </Grid>
                <Grid item xs={3}>
                    {nextAuditDate && (
                        <Typography
                            className="material-property-text"
                        >
                            <strong>Next Audit Date </strong>
                            {
                                nextAuditOverdue !== true ?
                                    nextAuditDate :
                                    <Chip color="error" label={nextAuditDate} />
                            }
                        </Typography>


                    )}
                    {lastAuditDate && (
                        <Typography className="material-property-text">
                            <strong>Last Audit Date </strong> {lastAuditDate}
                        </Typography>
                    )}
                    {material.responsibleEngineerAtLastAudit && (
                        <Typography className="material-property-text">
                            <strong>Responsible Engineer <small style={{ color: 'grey' }}>(at last audit)</small>: </strong>{material.responsibleEngineerAtLastAudit}
                        </Typography>
                    )}
                    {material.storageReason && (
                        <Typography className="material-property-text">
                            <strong>Storage Reason </strong>{material.storageReason}
                        </Typography>
                    )}
                    {material.retentionDecision && (
                        <Typography className="material-property-text">
                            <strong>Retention Decision </strong>{material.retentionDecision}
                        </Typography>
                    )}
                </Grid>

            </Grid>
    );
}
